/**
 * 日時フォーマット用の共通ユーティリティ。
 *
 * React コンポーネントと同じファイルから関数をエクスポートすると
 * Fast Refresh (react-refresh/only-export-components) の警告が出るため、
 * コンポーネント外で共有する関数はこのファイルに切り出している。
 */

/** JST 日時フォーマット用の Intl.DateTimeFormat (パフォーマンス最適化のため定数化) */
export const JST_DATE_TIME_FORMATTER = new Intl.DateTimeFormat('ja-JP', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  timeZone: 'Asia/Tokyo',
});

/**
 * null / 空文字は "—" に、それ以外は JST 表記の日時文字列にフォーマットする。
 * 不正な日時文字列（Date でパースできない）の場合も "—" を返す。
 */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return JST_DATE_TIME_FORMATTER.format(date);
}
